import React from 'react'
import { ref, onValue } from 'firebase/database'
import { db } from '../../'
import { Link } from 'react-router-dom'

const Watch = () => {
    const [gameId, setGameId] = React.useState('');
    const [gameData, setGameData] = React.useState(null);
    const [gameLog, setGameLog] = React.useState(null);
    const [error, setError] = React.useState(null);
    const unsubscribeGameRef = React.useRef(null);
    const unsubscribeGameLogRef = React.useRef(null);

    React.useEffect(() => {
        const watchGameID = localStorage.getItem('watchGameID');
        if(watchGameID) {
            setGameId(watchGameID);
            watchGame(watchGameID);
        }

        // アンマウント時にリスナーを解除
        return () => {
            if(unsubscribeGameRef.current) {
                unsubscribeGameRef.current();
                unsubscribeGameRef.current = null;
            }
            if(unsubscribeGameLogRef.current) {
                unsubscribeGameLogRef.current();
                unsubscribeGameLogRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ゲームデータ取得
    const watchGame = (targetGameId) => {
        const idToWatch = targetGameId || gameId;
        console.log('Watch game:', idToWatch);

        // 前のゲームのリスナーが残っていると、別のgameIdを観戦した際に
        // 古いデータで状態が上書きされ続けるため、まず解除してから新しく登録する
        if(unsubscribeGameRef.current) {
            unsubscribeGameRef.current();
            unsubscribeGameRef.current = null;
        }
        if(unsubscribeGameLogRef.current) {
            unsubscribeGameLogRef.current();
            unsubscribeGameLogRef.current = null;
        }

        // ゲームデータ取得
        const gameRef = ref(db, 'games/' + idToWatch);
        unsubscribeGameRef.current = onValue(gameRef, (snapshot) => {
            setGameData(snapshot.val());
            console.log('Game data:', snapshot.val());
            localStorage.setItem('watchGameID', idToWatch);

            if(!snapshot.val()) {
                setError('ゲームが存在しません');
            }
        });

        // ゲームログ取得
        const gameLogRef = ref(db, 'gameLogs/' + idToWatch);
        unsubscribeGameLogRef.current = onValue(gameLogRef, (snapshot) => {
            setGameLog(snapshot.val());
            console.log('Game log:', snapshot.val());

            if(!snapshot.val()) {
                setError('ゲームが存在しないか、まだ開始されていません');
            }
        });
    }

    return (
        <div className='p-3 mx-auto max-w-5xl pt-6 mb-3'>
            <h1 className='text-3xl text-center mb-8'><i className="bi bi-search me-2"></i>観戦</h1>

            <div className='max-w-xl mx-auto'>
                <label>ゲームID</label>
                <input onChange={(e) => setGameId(e.target.value)} value={gameId} type='text' className='w-full border border-gray-300 rounded-lg p-2 mb-4' />
                <button onClick={(e) => watchGame()} className='bg-purple-600 text-white rounded-lg p-2 w-full'>観戦する</button>
            </div>

            {error && (
                <div className='bg-red-100 text-red-700 p-3 rounded-lg mt-4'>
                    {error}
                </div>
            )}

            {
                (gameData && gameLog) && (
                    <div className='max-w-2xl mx-auto'>
                        <h2 className='text-2xl mt-8 text-purple-800 mb-2'>ゲーム情報</h2>
                        <div className='bg-white shadow p-4 rounded-lg mb-6 mx-4'>
                            <div className='mb-3'>
                                <label className='block text-sm font-medium text-gray-700'>ゲーム名</label>
                                <p className='text-xl ms-2'>{gameData.info.name}</p>
                            </div>

                            <div className='mb-3'>
                                <label className='block text-sm font-medium text-gray-700'>概要</label>
                                <p className='text-base text-gray-700 ms-2'>{gameData.info.detail}</p>
                            </div>

                            <div className='grid grid-cols-2 gap-4'>
                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700'>参加者数</label>
                                    <p className='text-lg ms-2'>{gameData.members ? gameData.members.length : 0} 人</p>
                                </div>

                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700'>チーム数</label>
                                    <p className='text-lg ms-2'>{gameData.teams ? gameData.teams.length : 0} 組</p>
                                </div>

                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700'>開始日時</label>
                                    <p className='text-lg ms-2'>{new Date(gameData.info.startTime).toLocaleString()}</p>
                                </div>

                                <div className='mb-3'>
                                    <label className='block text-sm font-medium text-gray-700'>終了日時</label>
                                    <p className='text-lg ms-2'>{new Date(gameData.info.endTime).toLocaleString()}</p>
                                </div>
                            </div>
                        </div>

                        <div className='grid grid-cols-3 max-w-2xl mx-auto mt-8'>
                            <Link to="/game/map" state={{gameId: gameId}} className='block rounded-xl bg-purple-100 text-purple-700 text-lg m-2 p-3 text-center border border-purple-300 hover:bg-purple-200'>
                                <i className='bi bi-map text-4xl'></i>
                                <h3 className='mt-2'>マップ</h3>
                            </Link>

                            <Link to="/game/allTeam" state={{gameId: gameId}} className='block rounded-xl bg-purple-100 text-purple-700 text-lg m-2 p-3 text-center border border-purple-300 hover:bg-purple-200'>
                                <i className='bi bi-trophy text-4xl'></i>
                                <h3 className='mt-2'>ランキング</h3>
                            </Link>

                            <Link to="/game/history" state={{gameId: gameId}} className='block rounded-xl bg-purple-100 text-purple-700 text-lg m-2 p-3 text-center border border-purple-300 hover:bg-purple-200'>
                                <i className='bi bi-clock-history text-4xl'></i>
                                <h3 className='mt-2'>履歴</h3>
                            </Link>
                        </div>
                    </div>
                )
            }
        </div>
    )
}

export default Watch
